import
  styled
from 'styled-components';

import {
  FontFamilies,
  FontSizes,
  Theme,
} from 'common';

const HBase = props => `
  color: ${props.color || Theme.Text.Color};
  ${props.fontFamily ? `font-family: ${props.fontFamily};` : `font-family: ${FontFamilies.Regular};`}
  ${props.padding ? `padding: ${props.padding};` : ''}
  ${props.lineHeight ? `line-height: ${props.lineHeight};` : ''}
  ${props.textAlign ? `text-align: ${props.textAlign};` : ''}
  ${props.textDecoration ? `text-decoration: ${props.textDecoration};` : ''}
  ${props.onClick ? `cursor: pointer;` : ''}
  ${props.width ? `width: ${props.width};` : ''}
  ${props.whiteSpace ? `white-space: ${props.whiteSpace};` : ''}
  ${props.textOverflow ? `text-overflow: ${props.textOverflow};` : ''}
  ${props.overflow ? `overflow: ${props.overflow};` : ''}
`;

export const H1 = styled.h1`
  margin: ${props => props.margin ? props.margin : '0.8em 0'};
  ${props => HBase(props)}
`;

export const H2 = styled.h2`
  margin: ${props => props.margin ? props.margin : '0.8em 0'};
  ${props => HBase(props)}
`;

export const H3 = styled.h3`
  margin: ${props => props.margin ? props.margin : '0.6em 0'};
  ${props => HBase(props)}
`;

export const H4 = styled.h4`
  font-size: ${props => props.fontSize || FontSizes.Regular};
  font-weight: ${props => props.fontWeight || 'bold'};
  margin: ${props => props.margin ? props.margin : '0.4em 0'};
  ${props => HBase(props)}
`;

const PBase = styled.span`
  display:  ${props => props.display || 'inline-block'};
  color: ${props => props.color || Theme.Text.Color};
  line-height: ${props => props.lineHeight || '1.5'};
  ${props => props.fontFamily && `font-family: ${props.fontFamily};`}
  ${props => props.padding && `padding: ${props.padding};`}
  ${props => props.textAlign && `text-align: ${props.textAlign};`}
  ${props => props.textDecoration && `text-decoration: ${props.textDecoration};`}
  ${props => props.whiteSpace && `white-space: ${props.whiteSpace};`}
  ${props => props.width && `width: ${props.width};`}
  ${props => props.maxWidth && `max-width: ${props.maxWidth};`}
  ${props => props.zIndex && `z-index: ${props.zIndex};`}
  ${props => props.onClick && `cursor: pointer;`}
  ${props => props.textOverflow && `text-overflow: ${props.textOverflow};`}
  ${props => props.overflow && `overflow: ${props.overflow};`}
  ${props => props.margin && `margin: ${props.margin};`}
`;

export const P = styled(PBase)`
  font-size: ${FontSizes.Regular};
`;

export const PSmall = styled(PBase)`
  font-size: ${FontSizes.Small};
`;

export const PSmaller = styled(PBase)`
  font-size: ${FontSizes.Smaller};
`;

// General text component
export const Text = styled(PBase)`
  font-size: ${props => props.fontSize || FontSizes.Regular};
`;
